// Configuración
const PARAM_NAME = "cart_variant";
const ATTRIBUTE_KEY = "cart_variant";

// Función principal
document.addEventListener("DOMContentLoaded", function () {
  // 1. Capturar parámetro de la URL
  const urlParams = new URLSearchParams(window.location.search);
  const paramValue = urlParams.get(PARAM_NAME);

  if (!paramValue) {
    console.log(`Parámetro ${PARAM_NAME} no encontrado en la URL`);
    return;
  }

  console.log(`Parámetro capturado: ${paramValue}`);

  // 2. Actualizar el carrito inmediatamente
  updateCartAttributes(paramValue)
    .then(() => {
      console.log("Atributo del carrito actualizado correctamente");
    })
    .catch((error) => {
      console.error("Error al actualizar:", error);
      // Si falla, guardar para uso posterior
      saveForLater(paramValue);
    });

  // 3. También escuchar eventos de agregar al carrito
  document.addEventListener("submit", function (e) {
    const form = e.target;
    if (form.matches('form[action*="/cart/add"]')) {
      // Agregar atributo oculto al formulario
      addHiddenAttribute(form, paramValue);
    }
  });

  // Escuchar clics en botones AJAX de agregar al carrito
  document.addEventListener("click", function (e) {
    if (e.target.matches("[data-add-to-cart], .product-form__submit")) {
      const savedValue = getSavedValue();
      if (savedValue) {
        setTimeout(() => updateCartAttributes(savedValue), 500);
      }
    }
  });
});

// Función para actualizar atributos del carrito
async function updateCartAttributes(value) {
  try {
    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        attributes: {
          [ATTRIBUTE_KEY]: value,
        },
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();
    console.log("Respuesta del carrito:", data);
    return data;
  } catch (error) {
    console.error("Error en updateCartAttributes:", error);
    throw error;
  }
}

// Guardar valor en sessionStorage para uso posterior
function saveForLater(value) {
  try {
    sessionStorage.setItem(`pending_${ATTRIBUTE_KEY}`, value);
    console.log("Valor guardado para uso posterior");
  } catch (e) {
    console.error("Error guardando en sessionStorage:", e);
  }
}

// Obtener valor guardado
function getSavedValue() {
  try {
    return sessionStorage.getItem(`pending_${ATTRIBUTE_KEY}`);
  } catch (e) {
    return null;
  }
}

// Agregar campo oculto al formulario
function addHiddenAttribute(form, value) {
  const existing = form.querySelector(
    `input[name="attributes[${ATTRIBUTE_KEY}]"]`
  );
  if (existing) {
    existing.value = value;
    return;
  }

  const input = document.createElement("input");
  input.type = "hidden";
  input.name = `attributes[${ATTRIBUTE_KEY}]`;
  input.value = value;
  form.appendChild(input);
}
